import { useTranslation } from 'react-i18next'
import useLogout from '../../hooks/use-logout'
import useAppData from '../../hooks/use-app-data'
import { Logout } from '@carbon/icons-react'

function SignoutButton ({ className = 'flex items-center text-white text-sm', logoutPath }) {
  const { t } = useTranslation()
  const logout = useLogout()
  const { currentUser } = useAppData()
  const title = t('glob_signOutButtonTitle', { username: currentUser?.username })

  return (
    <button title={title} className={className} onClick={() => logout(logoutPath)}>
      <span className='font-medium mr-4'>{t('glob_signOutButtonLabel')}</span>
      <Logout className='h-5 w-5' />
    </button>
  )
}

export default SignoutButton
